<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentRow">
        <div>
          <el-input placeholder="请输入产品名称" v-model="data.val" />
          <el-select v-model="data.scenicid" placeholder="全部景区" clearable>
            <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->
          <el-select v-model="data.UseFlag" placeholder="状态" clearable>
            <el-option
              v-for="item in use"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->
          <el-button class="btn1" type="primary" @click="cxBtns">查询</el-button>
          <!-- <el-button class="btn2" type="primary" @click="orderList()">订单列表</el-button> -->
        </div>
      </div>
      <el-table
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        :row-class-name="tableRowClassName"
        style="width: 100%"
      >
        <!-- <el-table-column label="序号" type="index"></el-table-column>-->
          
        <el-table-column prop="ProductID" label="产品ID"></el-table-column> 
        <el-table-column label="产品名称" width="220">
          <template slot-scope="scope">
              <div class="product_divs">
                <img src="@/assets/guoqi.png" alt="" v-if="!rows(scope.row)">
                <div :class="rows(scope.row)==true?'':'lg_css'">
                  {{scope.row.ProductName}}
                </div>
              </div>
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="景区名称"></el-table-column>
        <el-table-column prop="ScenicID" label="景区ID"></el-table-column>
        <el-table-column prop="Price" label="门市价"></el-table-column>
        <el-table-column prop="SellPrice" label="建议价"></el-table-column>
        <el-table-column prop="AgentPrice" label="代理价（注:日历票不参考此代理价）"></el-table-column>
        <el-table-column prop="ValidBeginDate" label="销售有效期" width="312">
            <template slot-scope="scope">{{ scope.row.ValidBeginDate }} - {{ scope.row.ValidEndDate }}</template>
        </el-table-column>
        <el-table-column prop="DayNumber" label="每日购买限制"></el-table-column>
        <el-table-column prop="AllNumber" label="总购买限制">
        </el-table-column>
        <el-table-column prop="address" label="状态">
          <template slot-scope="scope">
            <img src="@/images/distributor/dl.png" alt v-if="scope.row.UseFlag=='0'"/>
            <img src="@/images/distributor/dh.png" alt  v-if="scope.row.UseFlag=='1'"/>
            <span style="margin-left:5px">{{scope.row.UseFlag=='0'?'上架':'未上架'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="是否可退">
          <template slot-scope="scope">
            <img src="@/images/distributor/kt.png" alt v-if="scope.row.ReturnFlag=='0'" />
            <img src="@/images/distributor/bkt.png" alt  v-if="scope.row.ReturnFlag=='1'"/>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" width="210"    fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="proInfoFn(scope.row)">产品详情</el-button>
            <el-button type="text" @click="proPurchase(scope.row)">立即购买</el-button>
            <el-button type="text" @click="ordering(scope.row)">批量下单</el-button>
            <!-- <el-button type="text">加入订单</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <!-- <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div> -->
      <div class="pagination">
          <span class="totla">过期产品联系景区延期或下架</span>
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 排序弹框开始 -->
    <proListDialog v-if="orderListvisible" ref="orderListDialog" :name="proName" :goodId="goodId" @closeList="ListClose"></proListDialog>
    <!-- 排序弹框结束 -->

    <!-- 产品详情弹框开始 -->
    <proInfoDialog v-if="proInfovisible" ref="proInfoDialog" :productId="productId" @close="closeProduct"></proInfoDialog>
    <!-- 产品详情弹框结束 -->
    <orderInfo v-if="ordervisible" ref="orderInfoDialog"  @close="closeordering"></orderInfo>
  </div>
</template>

<script>
import proListDialog from "./dialog/proListDialog.vue";
import orderInfo from "./dialog/orderinfo.vue";

import proInfoDialog from "./dialog/proInfoDialog.vue";
import { getProductDistributorList,getDistrbutorScenicList,addDistributorOrder } from '@/request/distributor.js'
export default {
  components: {
    proListDialog,
    proInfoDialog,
    orderInfo
  },
  data() {
    return {
      ordervisible:false,
      productId:'', // 详情id
      orderListvisible: false, // 排序弹框
      proInfovisible: false, // 添加产品
      tableData: [],
      imgXlb: require("@/images/scenic/sj.png"),
      options: [
      ],
      value: "",
      total:1,
      data:{
        token:window.sessionStorage.getItem('Token'),
        scenicid:'',
        val:'',
        UseFlag:'',
        page:1,
        page_size:8
      },
      use:[
        {
          value:'0',
          label:'上架'
        },
        {
          value:'1',
          label:'下架'
        }
      ],
      proName:'',
      goodId:""
    };
  },
  created(){
    if(this.$route.query.id){
      this.data.scenicid = Number(this.$route.query.id) 
    }
    this.getList()
    this.secList()
  },
  methods: {
    rows(e){
      const startTime = new Date(e.ValidBeginDate); // 开始时间
      const endTime = new Date(e.ValidEndDate);
      const currentTime = new Date();
      if(e.UseFlag!=0){
        return false
      }
      if (currentTime >= startTime && currentTime <= endTime) {
        return true
      } else {
        return false
      }
    },
    closeordering(){
      this.ordervisible = false
    },
    ordering(row){
      this.ordervisible = true;
      this.$nextTick(() => {
        this.$refs.orderInfoDialog.proInfo(row);
      });
    },
    // 景区列表
    secList(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:999
        }
        getDistrbutorScenicList(data).then(res=>{
          if(res.data.status=='ok'){
            this.options = res.data.result.data
          }
        })
    },
    // 产品列表
    getList(){
      getProductDistributorList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.total = res.data.result.total
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    //查询
    cxBtns(){
      this.data.page = 1
      this.getList()
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    // 产品详情
    proInfoFn(row) {
      this.productId = row.ProductID
      this.proInfovisible = true;
      this.$nextTick(() => {
        this.$refs.proInfoDialog.proInfo();
      });
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    proPurchase(row){
      this.proName = row.Name
      this.goodId = row.ProductID
      this.orderListvisible = true;
      this.$nextTick(() => {
        this.$refs.orderListDialog.orderList();
      });
    },
    // 关闭下单
    ListClose(){
      this.orderListvisible = false
    },
    tableRowClassName({ row, rowIndex }) {
      // if(row.Status!=1){
      //   return "warning-row";
      // }
      let flow = this.rows(row)
      if(!flow){
        return "warning-row";
      }
      if(row.UseFlag!=0){
        return "warning-row";
      }
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 关闭详情
    closeProduct(){
      this.proInfovisible = false
    }
  }
};
</script>

<style lang='less' scoped>
::v-deep  .el-table .warning-row .cell {
  color: #B8B8B8;
}
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;
  .conentRow {
    margin: 20px 0;
    display: flex;
    .el-input {
      width: 240px;
      margin-right: 20px;
      margin-bottom: 1rem;
    }
    .el-select {
      width: 260px;
      margin-right: 20px;
      margin-bottom: 1rem;

    }
    .btn1 {
      margin-bottom: 1rem;

      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
      margin-right: 10px;
    }
    .btn2 {
      width: 110px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  position: relative;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .cell{
  display: flex;
  align-items: center;
  justify-content: center;
}
.totla{
  position: absolute;
  left: 2rem;
  width: 35rem;
  color: red !important;
  font-size: 1.6rem !important;
  font-weight: 800 !important;
}
.lg_css{
  color: #B8B8B8;
  font-weight: 600;
  font-size: 1.4rem;
}
.product_divs{
  position: relative;
  img{
    position: absolute;
    width: 6.2rem;
    height: 3rem;
    left: 3rem;
    transform: translate(-50%,0);
    z-index: 9;
  }
}
</style>